var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWellness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PRINT",
    xmlns: "http://www.w3.org/2000/svg",
    width: 181.348,
    height: 181.224,
    viewBox: "0 0 181.348 181.224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2619",
    "data-name": "Path 2619",
    d: "M33.063,114.218H5.41V6.57H33.063V114.157Z",
    transform: "translate(27.983 33.983)",
    fill: "#c784b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2620",
    "data-name": "Path 2620",
    d: "M25.727,6.57h0a7.3,7.3,0,0,0-7.284,7.284v100.3H33.073V13.854A7.3,7.3,0,0,0,25.789,6.57Z",
    transform: "translate(28.035 33.983)",
    fill: "#af5098"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2621",
    "data-name": "Path 2621",
    d: "M0,47.511A5.664,5.664,0,0,0,5.679,53.19h0a5.664,5.664,0,0,1,5.679,5.679v10h71.91v-10a5.664,5.664,0,0,1,5.679-5.679h0a5.664,5.664,0,0,0,5.679-5.679V21.71H.123v25.8Z",
    transform: "translate(0 112.295)",
    fill: "#c784b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2622",
    "data-name": "Path 2622",
    d: "M78.259,21.71H55.606a8.127,8.127,0,0,1,8.086,8.148V47.511a5.664,5.664,0,0,1-5.679,5.679h0a5.664,5.664,0,0,0-5.679,5.679v10H66.9v-10a5.664,5.664,0,0,1,5.679-5.679h0a5.664,5.664,0,0,0,5.679-5.679V21.71Z",
    transform: "translate(16.242 112.295)",
    fill: "#af5098"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2623",
    "data-name": "Path 2623",
    d: "M94.5,21.3a5.664,5.664,0,0,0-5.679-5.679h0a5.664,5.664,0,0,1-5.679-5.679V0H11.3V10a5.664,5.664,0,0,1-5.679,5.679h0A5.637,5.637,0,0,0,0,21.3V47.1H94.5Z",
    fill: "#c784b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2624",
    "data-name": "Path 2624",
    d: "M87.725,21.3a5.664,5.664,0,0,0-5.679-5.679h0a5.664,5.664,0,0,1-5.679-5.679V0H53.714A8.127,8.127,0,0,1,61.8,8.148v7.53H73.1V47.1H87.663V21.3Z",
    transform: "translate(6.776)",
    fill: "#af5098"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(50.306 47.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2625",
    "data-name": "Path 2625",
    d: "M21.106,43.456a2.75,2.75,0,0,1-2.716-2.531c-.062-.864-1.42-21.357,9.629-32.406a2.75,2.75,0,0,1,3.889,3.889c-4.815,4.753-6.728,12.1-7.53,17.406a56.716,56.716,0,0,0-.556,10.678,2.707,2.707,0,0,1-2.531,2.9h-.185Z",
    transform: "translate(44.384 -7.732)",
    fill: "#b289c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2626",
    "data-name": "Path 2626",
    d: "M100.12,11.4A39.168,39.168,0,0,0,73.64,21.708,39.054,39.054,0,0,0,8.15,50.225c.062,22.036,19.135,50.306,27.468,60.49,5.247,6.419,12.9,11.543,21.6,11.543a24.157,24.157,0,0,0,16.234-6.234.276.276,0,0,1,.309,0A24.04,24.04,0,0,0,90,122.258c8.7,0,16.357-5.123,21.6-11.543,8.333-10.185,27.406-38.455,27.468-60.49A38.935,38.935,0,0,0,100.058,11.4h0Z",
    transform: "translate(-8.15 11.238)",
    fill: "#b9f6d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2627",
    "data-name": "Path 2627",
    d: "M37.688,11.4a40.466,40.466,0,0,0-7.284.679A38.934,38.934,0,0,1,62.131,50.225C62.069,72.261,43,100.531,34.664,110.715a31.882,31.882,0,0,1-14.444,10.37,24.882,24.882,0,0,0,7.469,1.173c8.7,0,16.357-5.123,21.6-11.543C57.625,100.531,76.7,72.261,76.76,50.225A38.935,38.935,0,0,0,37.75,11.4h0Z",
    transform: "translate(54.282 11.238)",
    fill: "#9be69d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(24.443 51.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2628",
    "data-name": "Path 2628",
    d: "M62.2,16.01c-8.333,0-13.271,5.864-15.246,8.765a1.153,1.153,0,0,1-1.913,0c-2.592-4.136-10.987-13.95-28.023-5.185C.841,48.107,45.962,72.3,45.962,72.3S78.429,54.9,78.429,32.244A16.2,16.2,0,0,0,62.2,16.072h0Z",
    transform: "translate(-4.853 -16.01)",
    fill: "#ff6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2629",
    "data-name": "Path 2629",
    d: "M56,45.781h0a2.6,2.6,0,0,1-2.469-1.728l-6.172-15.8-1.049,2.284a7.2,7.2,0,0,1-6.6,4.2H14.826a2.716,2.716,0,0,1,0-5.432H40.874l4.259-9.135a2.813,2.813,0,0,1,2.592-1.6,2.751,2.751,0,0,1,2.469,1.728l6.111,15.555L59.823,27.7h32.1a2.716,2.716,0,0,1,0,5.432H63.465L58.712,44.052a2.779,2.779,0,0,1-2.531,1.667h0Z",
    transform: "translate(-12.11 -2.82)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellness);
export default __webpack_public_path__ + "static/media/wellness.b767cdfdb8e1b115492b4ce76cb519cf.svg";
export { ForwardRef as ReactComponent };